import styled from 'styled-components';
import { MediaQuery } from '../../theme/style-helpers';
import { H3 } from '../../theme/typographySitecore';

export const Container = styled.div`
  display: grid;
  grid-gap: 16px;
  margin: 80px 20px;
  justify-items: center;
  align-items: center;

  ${MediaQuery.medium`
    margin: 128px 20px;

    img {
      width: 152px;
    }
  `}

  ${MediaQuery.small`
    margin: 115px 20px;
  `}
`;

export const StyledH3 = styled(H3)`
  max-width: 648px;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 0;

  ${MediaQuery.medium`
    font-size: 36px;
    line-height: 47px;
  `}
`;
